import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { movieTopics } from "@/mocks/movies";

export default function TopicSection() {
  return (
    <section>
      <SectionTitle title="专题推荐区" subtitle="编辑部精选影单与专题策划" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {movieTopics.map((topic) => (
          <Link
            key={topic.id}
            to="/category/recommend"
            className="group relative block rounded-lg overflow-hidden h-56 md:h-64 cursor-pointer"
          >
            <img
              src={topic.cover}
              alt={`${topic.title} 专题封面`}
              title={`${topic.title} 影片专题 91电影`}
              className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/90 via-secondary-950/40 to-transparent" />
            <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
              <span className="inline-flex w-fit items-center gap-1 bg-accent-500 text-secondary-950 text-xs font-bold rounded-md px-2 py-1 mb-3">
                <i className="ri-bookmark-3-line" />
                专题
              </span>
              <h3 className="font-heading font-bold text-xl md:text-2xl text-background-50">
                {topic.title}
              </h3>
              <p className="text-background-200/90 text-sm mt-2 line-clamp-2">
                {topic.description}
              </p>
              <span className="inline-flex items-center gap-1 text-accent-400 text-sm font-medium mt-3">
                查看影单
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}